import { render } from "./DonutsDashboard.vue?vue&type=template&id=312c76b3"
import script from "./DonutsDashboard.vue?vue&type=script&lang=js"
export * from "./DonutsDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__